import useViewportSize from './useViewportSize';

export enum ViewType {
    mobile,
    pad,
    desktop,
}

export const PAD_START = 768;
export const DESKTOP_START = 1024;

const useViewType = (): ViewType => {
    const [viewportWidth] = useViewportSize();

    if (viewportWidth >= DESKTOP_START) {
        return ViewType.desktop;
    }

    if (viewportWidth >= PAD_START && viewportWidth < DESKTOP_START) {
        return ViewType.pad;
    }

    return ViewType.mobile;
};

export default useViewType;
